/**
 * Shared UI JS libraries. Use only what we need to keep the vendor file size smaller.
 *
 * @package
 */
require( '@wpmudev/shared-ui/dist/js/_src/code-snippet' );
require( '@wpmudev/shared-ui/dist/js/_src/modal-dialog' );
require( '@wpmudev/shared-ui/dist/js/_src/notifications' );
require( '@wpmudev/shared-ui/dist/js/_src/select2.full' );
require( '@wpmudev/shared-ui/dist/js/_src/select2' );
require( '@wpmudev/shared-ui/dist/js/_src/tabs' );
require( '@wpmudev/shared-ui/dist/js/_src/upload' ); // Used on lazy load page (since 3.2.2).
require( '@wpmudev/shared-ui/dist/js/_src/reviews' );
require( '@wpmudev/shared-ui/dist/js/_src/accordion' );
